export default (number: any) => {
  if (number === null) return false;
  if (number === undefined) return false;

  return !isNaN(Number(number));
};
